"use client";
import * as React from "react";
import { DataTable, type Column } from "../DataTable";
import { PageHeader, StatCard, Card2 } from "../ModuleHelpers";
import { ShieldCheck } from "lucide-react";

export function SecurityModule() {
  const roles = [
    { id: "r1", role: "CEO", users: 1, perms: 48, level: "Full Access" },
    { id: "r2", role: "Sales Manager", users: 4, perms: 32, level: "Sales + Approvals" },
    { id: "r3", role: "Procurement Officer", users: 3, perms: 24, level: "PO + GRN" },
    { id: "r4", role: "Warehouse Sup.", users: 5, perms: 18, level: "Stock + Pick" },
    { id: "r5", role: "Finance Manager", users: 2, perms: 36, level: "GL + Payments" },
    { id: "r6", role: "Driver (Mobile)", users: 8, perms: 8, level: "POD + Trips" },
  ];
  const auditLog = [
    { id: "al1", user: "Rumana Begum", action: "Posted JE-2026-4482", ip: "103.24.12.4", ts: "2026-10-13 14:32:11" },
    { id: "al2", user: "Sadia Islam", action: "Approved SO-2026-8821", ip: "103.24.12.18", ts: "2026-10-13 13:48:02" },
    { id: "al3", user: "Md. Hasan", action: "Posted GRN-2026-442", ip: "103.24.12.7", ts: "2026-10-13 11:20:45" },
    { id: "al4", user: "Arif Rahman", action: "Login (MFA)", ip: "103.24.12.1", ts: "2026-10-13 09:00:12" },
  ];
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Security & Audit" desc="Roles, permissions and complete audit trail." icon={ShieldCheck} />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label="Total Users" value="23" />
        <StatCard label="Active Roles" value={String(roles.length)} />
        <StatCard label="MFA Enabled" value="100%" tone="text-primary" />
        <StatCard label="Failed Logins (24h)" value="3" tone="text-destructive" />
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <Card2 title="Roles & Permissions">
          <DataTable
            columns={[
              { key: "role", header: "Role", sortable: true, render: r => <span className="font-medium">{r.role}</span> },
              { key: "users", header: "Users", align: "right" },
              { key: "perms", header: "Permissions", align: "right" },
              { key: "level", header: "Level" },
            ] as Column<typeof roles[number]>[]}
            data={roles}
            rowKey={r => r.id}
            searchKeys={["role", "level"]}
          />
        </Card2>
        <Card2 title="Audit Trail">
          <DataTable
            columns={[
              { key: "user", header: "User", sortable: true },
              { key: "action", header: "Action" },
              { key: "ip", header: "IP", render: r => <span className="font-mono text-xs">{r.ip}</span> },
              { key: "ts", header: "Timestamp" },
            ] as Column<typeof auditLog[number]>[]}
            data={auditLog}
            rowKey={r => r.id}
            searchKeys={["user", "action"]}
          />
        </Card2>
      </div>
    </div>
  );
}
